import Nullstack from 'nullstack';
export default function IconBoxPadding({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-padding",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M16 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M16 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M16 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v.01"
  }), " ");
}